import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { Countdown } from './Countdown';
import { Button } from './Button';
import ShieldIcon from '@mui/icons-material/Shield';
import LockIcon from '@mui/icons-material/Lock';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import BoltIcon from '@mui/icons-material/Bolt';
export function FinalCTASection() {
  return <SectionWrapper className="bg-secondary pb-24" data-id="element-82">
      <div className="max-w-xl mx-auto text-center" data-id="element-83">
        <div className="mb-8" data-id="element-84">
          <p className="text-red-600 font-bold uppercase tracking-wider mb-4" data-id="element-85">
            ⏰ EL PRECIO CIERRA EN:
          </p>
          <Countdown data-id="element-86" />
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-primary" data-id="element-87">
          <div className="bg-primary text-white p-6 text-center" data-id="element-88">
            <h2 className="font-serif text-2xl font-bold mb-2" data-id="element-89">
              🌿 REINICIO INTERNO™ — KIT COMPLETO
            </h2>
            <p className="text-primary-dark text-sm font-medium opacity-90" data-id="element-90">
              Reset Digestivo + 5 Bonos
            </p>
          </div>

          <div className="p-8 text-center" data-id="element-91">
            <div className="flex justify-center items-center gap-4 mb-6" data-id="element-92">
              <span className="text-2xl text-gray-400 line-through font-bold" data-id="element-93">
                $66.000
              </span>
              <span className="text-5xl font-bold text-gray-900" data-id="element-94">
                $19.990 <span className="text-xl text-gray-500" data-id="element-95">ARS</span>
              </span>
            </div>

            <Button fullWidth className="mb-6 py-5 text-xl shadow-xl shadow-green-500/20" data-id="element-96">
              🟢 → QUIERO MI REINICIO INTERNO AHORA
            </Button>

            <div className="grid grid-cols-2 gap-4 text-sm text-gray-600 bg-gray-50 p-4 rounded-xl" data-id="element-97">
              <div className="flex items-center justify-center" data-id="element-98">
                <LockIcon fontSize="small" className="mr-2 text-primary" data-id="element-99" /> Pago
                100% seguro
              </div>
              <div className="flex items-center justify-center" data-id="element-100">
                <BoltIcon fontSize="small" className="mr-2 text-amber-500" data-id="element-101" />{' '}
                Acceso en 5 minutos
              </div>
              <div className="flex items-center justify-center" data-id="element-102">
                <ShieldIcon fontSize="small" className="mr-2 text-primary" data-id="element-103" />{' '}
                Garantía 7 días
              </div>
              <div className="flex items-center justify-center" data-id="element-104">
                <CreditCardIcon fontSize="small" className="mr-2 text-primary" data-id="element-105" />{' '}
                M. Pago · Tarjeta · Transf.
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}